<template>
    <div class="applications-page">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t('sideMenu.myApps') }}</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card applications-card">
                        <!--
                        <div class="border-0 card-header">
                            <h3 class="mb-0">Light table</h3>
                        </div>
                        -->
                        <div class="card-body">
                            <div class="applications">
                                <div class="row">
                                    <div v-for="app in applications" :key="app.id" class="col-lg-3 col-md-4 col-sm-6">
                                        <a
                                            :href="app.url"
                                            class="application">
                                            <div class="icon mx-auto">
                                                <img
                                                    v-if="app.logo_url"
                                                    :src="app.logo_url"
                                                    :alt="app.name"
                                                    :title="app.name"
                                                    class="image-icon">
                                                <div
                                                    v-else
                                                    class="text-icon"
                                                    :class="getRandomBackgroundColor">{{ app.name[0] }}
                                                </div>
                                            </div>
                                            <h5 class="name text-uppercase text-muted">{{ app.name }}</h5>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import RandomBackgroundColor from '@/mixins/random-background-color'

    export default {
        mixins: [RandomBackgroundColor],
        computed: {
            applications(){
                return this.$store.state.user.applications;
            }
        },
        created(){
            this.$store.dispatch('refreshUser');
        }
    };
</script>

<style lang="scss">
    .applications-card {
        min-height: 55vh;

        .row {
            width: 100%;
            max-width: 1200px;
        }
    }

    .applications {
        display: flex;
        padding: 30px;

        .application {
            display: block;
            width: 100%;
            height: 400px;
            border: 1px solid #efefef;
            border-radius: .375rem;
            margin-right: 15px;
            margin-bottom: 15px;
            cursor: pointer;
            transition: all 0.15s ease;

            &:hover {
                border-color: darken(#efefef, 5%);
            }

            .icon {
                width: 60%;
                height: 130px;
                padding: 10px;

                margin-top: 110px;
                margin-bottom: 0px;

                .image-icon {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    object-position: center center;
                }

                .text-icon {
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #fff;
                    text-transform: uppercase;
                    text-align: center;
                    border-radius: 500px;
                    max-width: 100px;
                    max-height: 100px;
                    line-height: 100px;
                    margin: auto;
                    font-size: 50px;
                }
            }

            .name {
                text-align: center;
                line-height: 50px;
                color: initial;
            }
        }
    }
</style>
